import styles from "../styles/Hero.module.css";

function Hero() {
  return (
    <section id="home" className={styles.hero}>
      <div className={styles.overlay}></div>

      <div className={styles.content}>
        <span className={styles.subtitle}>
          COCKTAILS • FOOD • GOOD VIBES
        </span>

        <h1>
          Where Great
          <br />
          Nights Begin
        </h1>

        <p>
          Discover handcrafted cocktails, delicious cuisine, and an atmosphere
          designed for unforgettable evenings with friends.
        </p>

        <div className={styles.buttons}>
          <a href="#menu" className={styles.primary}>
            View Menu
          </a>

          <a href="#contact" className={styles.secondary}>
            Reserve Table
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;